import { DocumentList } from "@l2r-front/l2r-app-doc"
import { styled } from "@l2r-front/l2r-ui"

export const List = styled(DocumentList)(({ theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    flex: 1,
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
}))